module.exports = __webpack_public_path__ + "3e196e78d697d1c7da44f763c16b8798.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-1.png
// module id = 3592
// module chunks = 0